import { render } from "./StudioMultiselect.vue?vue&type=template&id=5bd53526&scoped=true&ts=true"
import script from "./StudioMultiselect.vue?vue&type=script&lang=ts"
export * from "./StudioMultiselect.vue?vue&type=script&lang=ts"

import "./StudioMultiselect.vue?vue&type=style&index=0&id=5bd53526&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd53526"]])

export default __exports__